import React from 'react';
import { Icon } from 'semantic-ui-react';
var defaultProps = {
  cartDisplayTitle: 'Order Summary',
  mobileCartOpen: false,
  numberOfItems: 1
};
var MenuCartDisplayBanner = function MenuCartDisplayBanner(_ref) {
  var cartDisplayTitle = _ref.cartDisplayTitle,
    onToggleMobileCart = _ref.onToggleMobileCart,
    mobileCartOpen = _ref.mobileCartOpen,
    numberOfItems = _ref.numberOfItems;
  return /*#__PURE__*/React.createElement("div", {
    className: "menu-cart-banner",
    onClick: onToggleMobileCart,
    onKeyDown: onToggleMobileCart,
    role: "button",
    tabIndex: -1
  }, /*#__PURE__*/React.createElement("h4", null, cartDisplayTitle), /*#__PURE__*/React.createElement("h4", null, numberOfItems, " Item", numberOfItems !== 1 ? 's' : ''), /*#__PURE__*/React.createElement("div", {
    className: "menu-cart-mobile"
  }, /*#__PURE__*/React.createElement(Icon, {
    className: mobileCartOpen ? 'flip' : '',
    name: "angle up",
    size: "large",
    onClick: onToggleMobileCart
  })));
};
MenuCartDisplayBanner.defaultProps = defaultProps;
export default MenuCartDisplayBanner;